import React from 'react'

const TextArea = (props) => (
	<textarea
		defaultValue={props.value}
		name={props.name}
		type={props.inputType}
		placeholder={props.placeholder}
		id={props.id}
		onChange={(e) => props.controlFunc(e.target.name, e.target.value, e.target.id)}
	></textarea>
)

export default TextArea


// WEBPACK FOOTER //
// ./src/components/Fields/TextArea.js